"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("./core");
var browser_performance_1 = require("./browser-performance");
var spm_1 = require("./spm");
var collTracker = window['__CollTracker'];
// 改为单实例，业务方要保证setConfig的正确性，后setConfig 会覆盖前面的值
if (!(collTracker && (collTracker instanceof core_1.Coll))) {
    collTracker = new core_1.Coll();
    browser_performance_1.default(collTracker);
    spm_1.default(collTracker);
}
window['__CollTracker'] = collTracker;
exports.default = collTracker;
//# sourceMappingURL=index.js.map